export default __webpack_public_path__ + "static/media/9.561c2b0c.svg";